// LIST
export const FETCH_RATES = "app/HOURLY_RATE/FETCH_RATES";
export const FETCH_RATES_SUCCESS = "app/HOURLY_RATE/FETCH_RATES_SUCCESS";
export const FETCH_RATES_FAILURE = "app/HOURLY_RATE/FETCH_RATES_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/HOURLY_RATE/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/HOURLY_RATE/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/HOURLY_RATE/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_RATE = "app/HOURLY_RATE/ADD_RATE";
export const ADD_RATE_SUCCESS = "app/HOURLY_RATE/ADD_RATE_SUCCESS";
export const ADD_RATE_FAILURE = "app/HOURLY_RATE/ADD_RATE_FAILURE";

// EDIT
export const EDIT_RATE = "app/HOURLY_RATE/EDIT_RATE";
export const EDIT_RATE_SUCCESS = "app/HOURLY_RATE/EDIT_RATE_SUCCESS";
export const EDIT_RATE_FAILURE = "app/HOURLY_RATE/EDIT_RATE_FAILURE";

// DELETE
export const DELETE_RATE = "app/HOURLY_RATE/DELETE_RATE";
export const DELETE_RATE_SUCCESS = "app/HOURLY_RATE/DELETE_RATE_SUCCESS";
export const DELETE_RATE_FAILURE = "app/HOURLY_RATE/DELETE_RATE_FAILURE";

export const TOGGLE_RATE_ADD_MODAL = "app/HOURLY_RATE/TOGGLE_RATE_ADD_MODAL";
